import { formatCents } from '@src/common';
import React, { useMemo } from 'react';

import { DetailedSaleItem } from '@src/core/buyerApiClient';
import useTranslate from '@src/i18n/useTranslate';
import { getSaleItemPackageDiscountCents } from '@src/domains/sale-items';
import SaleItem from '../SaleItem';
import {
  PackageDiscountValue,
  PackageOriginalPrice,
  PackagePriceInfo,
  PackagePrices,
  PackageTotalPrice,
} from '@src/components/Checkout/styles';
import useShowItemPrices from '@src/hooks/useShowItemPrices';

interface ProductPackageItemProps {
  item: DetailedSaleItem;
}

const ProductPackageItem = (props: ProductPackageItemProps) => {
  const { item } = props;
  const { i18n } = useTranslate();
  const discountValue = useMemo(() => getSaleItemPackageDiscountCents(item), [item]);
  const showItemPrices = useShowItemPrices();

  return (
    <SaleItem item={item}>
      {showItemPrices ? (
        <PackagePrices>
          <PackagePriceInfo>
            {i18n('cart_package_previous_price')}
            <PackageOriginalPrice>{formatCents(item.fullPriceCurrencyInfo.amountCents)}</PackageOriginalPrice>
          </PackagePriceInfo>

          <PackagePriceInfo>
            {i18n('cart_package_discount')}
            <PackageDiscountValue>-{formatCents(discountValue)}</PackageDiscountValue>
          </PackagePriceInfo>

          <PackagePriceInfo>
            {i18n('cart_package_total')}
            <PackageTotalPrice>{formatCents(item.totalPriceCurrencyInfo.amountCents)}</PackageTotalPrice>
          </PackagePriceInfo>
        </PackagePrices>
      ) : null}
    </SaleItem>
  );
};

export default ProductPackageItem;
